class ProductClipFetch extends HTMLElement {
    constructor() {
        super()
        this.content = null
        this.handle = this.dataset.handle
        this.url = `${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-clip`;
        this.id = this.getAttribute('data-clerk-product-id')
        this.renderContent()
    }

    async fetchContent(){
        const response = await fetch(this.url)
   
        const content = await response.text()
        const html = new DOMParser().parseFromString(content, 'text/html')
        this.content = html.querySelector('.product-clip-outer')   
        // Adding clerk attributes for tracking purposes
        this.content.querySelectorAll('a').forEach((anchor) => {
            anchor.setAttribute('data-clerk-product-id', this.id)
            anchor.setAttribute('data-clerk-click-tracking-added', true)
        })
    }

    async renderContent(){
        await this.fetchContent()
        if (this.content) {
            // Insert the fetched content into the current element
            this.innerHTML = this.content.outerHTML;

            this.rendered = true;
        } else {
            console.error('Product grid item content is missing');
        }
    }
    
}

customElements.define('product-clip-fetch', ProductClipFetch)